<template>
    <div>
        <product-scanned-info :dispatch-request-line="suggestedScanLine" class="mr-1 d-inline-block"/>

        <div class="mt-2">
            <small>
                <b-button variant="link" @click.prevent="isModalOpen = true" class="text-info p-0 m-0">
                    <small>{{ suggestedScanLine.product_identifier }}</small>
                </b-button>
                <span class="d-inline-block text-black-50 mx-2"> &bull;</span>
                <i v-if="!hasDiscount">{{ originalUnitPrice }} p/s</i>
                <i v-else>
                    <s>{{ originalUnitPrice }}</s> {{ discountUnitPrice }} p/s
                </i>
                <span class="d-inline-block text-black-50 mx-2"> &bull;</span>
                <i>aantal: {{ suggestedScanLine.quantity_pending }}</i>
            </small>
        </div>

        <b-modal v-model="isModalOpen" hide-footer :title-html="`<h3 class='mb-0'>${suggestedScanLine.product_identifier}</h3>`">
            <font-awesome-icon v-if="isLoadingProductInfo" icon="spinner" spin/>
            <div v-else>
                <h3>{{ suggestedScanLine.sales_order_line?.product_name }}</h3>

                <img :src="getProductAttributeValue('image_url')" alt="" style="max-width:100%;" class="d-block my-4"/>

                <p class="font-size-lg">
                    <span v-if="!hasDiscount">
                        {{ originalUnitPrice }}
                    </span>
                    <span v-else>
                        Van <s>{{ originalUnitPrice }}</s>
                        voor {{ discountUnitPrice }}
                    </span>
                </p>
                <b-row class="font-size-lg mt-4">
                    <b-col v-for="(eanCode, index) in suggestedScanLine.ean_codes" cols="6">
                        {{ eanCode }}
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ProductScannedInfo from "@/views/ProductProcessing/Components/ProductScannedInfo.vue";
import ProductNumber from "@/components/ProductNumber.vue";
import {price} from "@/helpers/numbers";

export default {
    name: 'ShowSuggestedScanLine',

    components: {
        ProductNumber,
        ProductScannedInfo,
    },

    props: {
        suggestedScanLine: {required: true, type: Object},
    },

    data() {
        return {
            isModalOpen: false,
            isLoadingProductInfo: true,
        }
    },

    computed: {
        product() {
            return this.$store.state.products[this.suggestedScanLine.product_identifier]
        },
        originalUnitPrice() {
            return price(this.suggestedScanLine.sales_order_line.original_line_gross_price / this.suggestedScanLine.sales_order_line.quantity)
        },
        discountUnitPrice() {
            return price(
                (this.suggestedScanLine.sales_order_line.original_line_gross_price - this.suggestedScanLine.sales_order_line.discount_amount)
                / this.suggestedScanLine.sales_order_line.quantity
            )
        },
        hasDiscount() {
            return parseFloat(this.suggestedScanLine.sales_order_line.discount_amount) > 0.0
        },
    },

    methods: {
        getProductAttributeValue(attribute) {
            return this.product?.attribute_values.find(val => val.product_attribute?.identifier === attribute)?.value
        },
    },

    watch: {
        isModalOpen(val) {
            if (!val || !this.isLoadingProductInfo) {
                return
            }

            this.$store.getters.getProductInfo(this.suggestedScanLine.product_identifier)
                .finally(() => this.isLoadingProductInfo = false)
        },
    }
}
</script>
